// import UserBankAccounts from "./UserBankAccounts";
import { useTranslation } from "react-i18next";
import { Col, Dropdown, Spinner } from "react-bootstrap";
import { BsFileEarmarkExcelFill, BsFileEarmarkPdfFill } from "react-icons/bs";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";
import Tabs, { Tab } from "react-best-tabs";
import "react-best-tabs/dist/index.css";
import CustomTable from "../../components/DataTable/CustomTable";
import TableHeader from "../../components/DataTable/TableHeader";
import { UserPlus } from "lucide-react";
import { useSelector } from "react-redux";
import { selectUser } from "../../features/auth/authSlice";
import { forwardRef, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Accounts from "./Accounts";
import { getAdminAllHREmployees, getAllRolesForDropDown } from "../../services/authapi";
import { useEffect } from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { serialNumber } from "../../utils/helper";
import ActionButtons from "../../components/DataTable/ActionButtons";
import { formatNumberToINR } from "../../utils/helper";
import { getAllAreaManager, getAllEndUserBySupervisorId, getSupervisorListWithTotalFreeUserByManagerId, downloadUserWiseReport, downloadComplaintWiseReport, downloadUserAccountsItemwiseReport } from "../../services/contractorApi";
import DynamicFilter from "../../components/DynamicFilter/DynamicFilter";

// Caret-less dropdown toggle so the header download icon renders as a plain
// icon (same look as the existing report icons), not a bootstrap button.
const IconToggle = forwardRef(({ children, onClick }, ref) => (
    <span
        ref={ref}
        role="button"
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
        style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}
    >
        {children}
    </span>
));

const UserBankAccounts = ({ checkPermission }) => {
    const columnHelper = createColumnHelper();
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { t } = useTranslation();
    const { userPermission } = useSelector(selectUser);
    const [isLoading, setIsLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [totalData, setTotalData] = useState(0);
    const [idToDelete, setIdToDelete] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const { user } = useSelector(selectUser);
    const [activeTab, setActiveTab] = useState(
        localStorage.getItem("last_tab") || "2"
    );
    const [dropdownOptions, setDropdownOptions] = useState({});
    const [isDropdown, setIsDropdown] = useState(false);
    const [supervisorData, setSupervisorData] = useState([]);
    const [endUserData, setEndUserData] = useState([]);
    const pageNo = searchParams.get("pageNo") || 1;
    const pageSize = searchParams.get("pageSize") || 10;
    const [search, setSearch] = useState("");

    const [filters, setFilters] = useState({
    emplyoee_name: [],
    bank_name: [],
    account_number: [],
    role:[],
    fromDate: [],
    toDate: [],
});

const fetchTransferedFundData = async (customFilter = {}) => {
  setIsLoading(true);

const payload = {
  search,
  pageSize,
  pageNo,
  for_expense_punch: true,

role:
    customFilter.role?.value ??
    customFilter.role ??
    "",

  emplyoee_id:
    customFilter.emplyoee_name?.value ??
    customFilter.emplyoee_name ??
    "",

  manager:
    customFilter.manager?.value ??
    customFilter.manager ??
    "",

  supervisor:
    customFilter.supervisor?.value ??
    customFilter.supervisor ??
    "",

  end_user:
    customFilter.end_user?.value ??
    customFilter.end_user ??
    "",

  from_date: customFilter.fromDate || "",
  to_date: customFilter.toDate || "",
};

  console.log("FINAL FILTER PAYLOAD =>", payload);

  const res = await getAdminAllHREmployees(payload);

  if (res.status) {
    setRows(res.data);
    setTotalData(res.pageDetails?.total || 0);
  } else {
    setRows([]);
    setTotalData(0);
  }

  setIsLoading(false);
};

const fetchDropdownData = async () => {
    const res = await getAdminAllHREmployees({
      search,
      pageSize,
      pageNo,
      isDropdown: true,
      for_expense_punch:true,
      request_by: user.id,
 
      area_manager_id: filters.area_manager_id,
      supervisor_id: filters.supervisor,
      from_date: filters.fromDate,
      to_date: filters.toDate,
      created_for: filters.created_for,
      created_for_id: filters.created_for_id,
    });
    setIsDropdown(res.data);
    setIsLoading(false);
    const seenSupervisors = new Set();
    const seenManagers = new Set();
    const seenEnduser = new Set();
    setFilters((prev) => {
      const seenEmp = new Set();

const emplyoee_name = res?.data
?.filter(
(item) =>
item.id &&
item.name &&
!seenEmp.has(item.id) &&
seenEmp.add(item.id)
)
.map((item) => ({
label: item.name,
value: item.id,
}));

  console.log("EMP OPTIONS:", emplyoee_name);



      const seenSupervisors = new Set();
      const supervisor = res?.data
        ?.filter(
          (item) =>
            item.supervisor_id &&
            item.supervisor_name &&
            !seenSupervisors.has(item.supervisor_id) &&
            seenSupervisors.add(item.supervisor_id)
        )
        .map((item) => ({
          label: item.supervisor_name,
          value: item.supervisor_id,
        }));

      const seenManagers = new Set();

// const manager = res?.data
//   ?.filter(
//     (item) =>
//       item.role_name === "Manager" &&
//       !seenManagers.has(item.id) &&
//       seenManagers.add(item.id)
//   )
//   .map((item) => ({
//     label: item.name,
//     value: item.id,
//   }));
      const seenBank = new Set();
     const bank_name = res?.data
?.filter(
(item) =>
item.bank_name &&
!seenBank.has(item.bank_name) &&
seenBank.add(item.bank_name)
)
.map((item) => ({
label: item.bank_name,
value: item.bank_name,
}));

      const seenAccount = new Set();

const account_number = res?.data
?.filter(
(item) =>
item.account_number &&
!seenAccount.has(item.account_number) &&
seenAccount.add(item.account_number)
)
.map((item) => ({
label: item.account_number,
value: item.account_number,
}));

       
        const seenEnd = new Set();

const end_user = res?.data
  ?.filter(
    (item) =>
      item.end_users_id &&
      item.end_user_name &&
      !seenEnd.has(item.end_users_id) &&
      seenEnd.add(item.end_users_id)
  )
  .map((item) => ({
    label: item.end_user_name,
    value: item.end_users_id,
    supervisor_id: item.supervisor_id   // ⭐ important
  }));
console.log("END OPTIONS:", end_user);

      return {
        ...prev,
        // Employee_Id,
        emplyoee_name,
        supervisor,
        end_user,
        // manager,
        bank_name,
        account_number,
      };
    });
  };

const fetchEndUsersBySupervisor = async (id) => {

  const res = await getAllEndUserBySupervisorId(id);

  if (res.status) {

    const endUsers = res.data.map((item) => ({
      label: item.name,
      value: item.id
    }));

    setEndUserData(endUsers);

  } else {
    setEndUserData([]);
  }

};

  const fields = useMemo(
      () => [
  
        {
          key: "emplyoee_name",
          label: "Employee Name",
          options: filters.emplyoee_name,
          value: dropdownOptions.emplyoee_name || "",
          type: "select",
        },
  
        {
          key: "manager",
          label: " Manager",
          options: filters.manager,
          value: dropdownOptions.manager || "",
          type: "select",
        },
        {
  key: "supervisor",
  label: "Supervisor",
  options: supervisorData.length ? supervisorData : filters.supervisor,
  value: dropdownOptions.supervisor || "",
  type: "select",
},
         {
  key: "end_user",
  label: "End User",
  options: endUserData.length ? endUserData : filters.end_user,
  value: dropdownOptions.end_user || "",
  type: "select",
},
  
        {
          key: "fromDate",
          label: "From Date",
  
          value: dropdownOptions.fromDate || "",
          type: "date",
        },
        {
          key: "toDate",
          label: "To Date",
          value: dropdownOptions.toDate || "",
  
          type: "date",
        },
        {
  key: "role",
  label: "User Role",
  options: filters.role,
  value: dropdownOptions.role || "",
  type: "select",
},
      ],
      [filters, dropdownOptions,supervisorData,endUserData]
    );

    const columns = [
        columnHelper.accessor("sr_no", {
            header: t("Sr No."),
            cell: (info) => {
                const serialNumbers = serialNumber(pageNo, pageSize);
                return serialNumbers[info.row.index];
            },
        }),
        {
            accessorKey: "name",
            header: "Name",
            // Employee ID shown stacked UNDER the name (no separate column) —
            // mirrors the "Request For" style elsewhere in the app.
            cell: (info) => (
                <div className="d-grid">
                    <span>{info.row.original.name || "-"}</span>
                    {info.row.original.employee_id ? (
                        <span
                            className="small"
                            style={{ color: "#6b7280" }}
                        >
                            ({info.row.original.employee_id})
                        </span>
                    ) : null}
                </div>
            ),
        },
        {
            accessorKey: "account_number",
            header: "Account Number",
        },
        {
            accessorKey: "ifsc_code",
            header: "IFSC Code",
        },
        {
            accessorKey: "bank_name",
            header: "Bank Name",
        },
        {
    accessorKey: "role_name",
    header: "Role",
    cell: (info) => info.row.original.role_name || "-"
},
        {
            accessorKey: "manager_name",
            header: "Manager",
            cell: (info) => info.row.original.manager_name || "-",
        },
        {
            accessorKey: "supervisor_name",
            header: "Supervisor",
            cell: (info) => info.row.original.supervisor_name || "-",
        },
        columnHelper.accessor("opening_balance", {
            header: "Opening Balance",
            cell: (info) => (
                <td style={{ color: "green" }} className="fw-bold">
                    ₹ {Number(info.row.original.opening_balance || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </td>

            ),
        }),
        columnHelper.accessor("closing_balance", {
            header: "Closing Balance",
            cell: (info) => {
                const amount = Number(info.row.original.closing_balance || 0);
                const formattedAmount = amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

                return (
                    <td style={{ color: "green" }} className="fw-bold">
                        ₹ {formattedAmount}
                    </td>
                );
            },
        }),

        columnHelper.accessor("action", {
            header: t("Action"),
            cell: (info) => (
                <ActionButtons
                    actions={{
                        view: {
                            show: checkPermission?.view,

                            action: () =>
                                navigate(
                                    `/account-management/view-transaction/${info.row.original?.id}?type=details&isuser=true`
                                ),
                        },
                    }}
                />
            ),
        }),

    ];

    const fetchAllHrEmployeesData = async () => {
         setIsLoading(true);
        const res = await getAdminAllHREmployees({
            search,
            pageSize,
            pageNo,
            forAccount: true,
        });
        if (res.status) {
            const data = res.data.filter((item) => item.is_creditor == 0 );
            setRows(data);

            setTotalData(res?.pageDetails?.total);
        } else {
            setRows([]);
            setTotalData(0);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        fetchAllHrEmployeesData();
        fetchDropdownData();
        fetchManagers();
        fetchRoles();
    }, [search, pageNo, pageSize]);

const fetchManagers = async () => {
  const res = await getAllAreaManager();

  if (res.status) {

    const managers = res.data.map((item) => ({
      label: item.name,
      value: item.id,
    }));

    setFilters((prev) => ({
      ...prev,
      manager: managers
    }));

  } else {
    setFilters((prev) => ({
      ...prev,
      manager: []
    }));
  }
};

const fetchRoles = async () => {

  const res = await getAllRolesForDropDown();

  if (res.status) {

    const roles = res.data.map((item) => ({
      label: item.name,
      value: item.name
    }));

    setFilters((prev) => ({
      ...prev,
      role: roles
    }));

  } else {

    setFilters((prev) => ({
      ...prev,
      role: []
    }));

  }
};

const fetchSupervisorsByManager = async (id) => {
    const res = await getSupervisorListWithTotalFreeUserByManagerId(id);
    if (res.status) {
      const supervisor = res.data.map((item) => ({
  label: item.name,
  value: item.id,
}));

setSupervisorData(supervisor);
    } else {
      setSupervisorData([]);
      // toast.error(res.message);
    }
  };

    // Export handler — CustomTable injects { type, columns } (type "1"=excel, "2"=pdf).
    // We forward the currently-applied filters so the report matches what the user sees.
    // Backend (getAllStoredEmployeeDetails) enters export mode when pageSize is absent.
    // "" | "summary-excel" | "summary-pdf" | "userwise-excel" | "userwise-pdf"
    const [busyReport, setBusyReport] = useState("");

    const triggerBrowserDownload = (axiosResponse, fallbackName) => {
        const cd = axiosResponse?.headers?.["content-disposition"] || "";
        const match = cd.match(/filename="?([^";\n]+)"?/);
        // Download names use hyphens, never underscores — same rule the backend applies.
        const filename = (match ? match[1].trim() : fallbackName).replace(/[_\s]+/g, "-");
        const url = window.URL.createObjectURL(new Blob([axiosResponse.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    };

    // Columns exported in the Summary (list) report — mirrors the on-screen
    // table minus the UI-only Sr No / Action columns.
    const SUMMARY_EXPORT_COLUMNS = [
        "name",
        "account_number",
        "ifsc_code",
        "bank_name",
        "role_name",
        "manager_name",
        "supervisor_name",
        "opening_balance",
        "closing_balance",
    ];

    // Summary Report = current filtered user list (existing export path).
    const handleSummaryReport = async (fmt) => {
        if (busyReport) return;
        setBusyReport(`summary-${fmt}`);
        try {
            const res = await handleUserAccountExport({
                type: fmt === "excel" ? "1" : "2",
                columns: JSON.stringify(SUMMARY_EXPORT_COLUMNS),
            });
            if (res?.status && res.filePath) {
                window.open(`${process.env.REACT_APP_API_URL}${res.filePath}`, "_blank");
            } else {
                toast.error(res?.message || "Failed to generate Summary Report");
            }
        } finally {
            setBusyReport("");
        }
    };

    // Complaint Wise Report = per-complaint breakdown for the filtered
    // Manager / Supervisor / End User. Same MP/SP/EP formulas as the
    // Complaint Summary Report — simplified 7-column layout.
    const handleComplaintWiseReport = async (fmt) => {
        if (busyReport) return;
        setBusyReport(`complaintwise-${fmt}`);
        try {
            const res = await downloadComplaintWiseReport(
                dropdownOptions.fromDate || "",
                dropdownOptions.toDate || "",
                fmt,
                {
                    manager: dropdownOptions.manager || "",
                    supervisor: dropdownOptions.supervisor || "",
                    end_user: dropdownOptions.end_user || "",
                    // USER ROLE dropdown (SUPERVISOR / MANAGER / …) and
                    // EMPLOYEE NAME dropdown — backend resolves these to the
                    // same user set the on-screen list shows, then filters
                    // complaints to those with any of those users in the
                    // timeline. Previously ignored → report ignored the filter.
                    role: dropdownOptions.role || "",
                    emplyoee_id: dropdownOptions.emplyoee_name || "",
                },
            );
            if (res?.data) {
                triggerBrowserDownload(
                    res,
                    `Complaint_Wise_Report.${fmt === "excel" ? "xlsx" : "pdf"}`,
                );
            } else {
                toast.error(res?.message || "Failed to generate Complaint Wise Report");
            }
        } finally {
            setBusyReport("");
        }
    };

    // Item-wise Report = page 1 the Summary Report (same filters), then every
    // item the filtered hierarchy received: item / HSN / rate / qty /
    // supplier / purchase date / amount / user.
    const handleItemwiseReport = async (fmt) => {
        if (busyReport) return;
        setBusyReport(`itemwise-${fmt}`);
        try {
            const res = await downloadUserAccountsItemwiseReport(
                dropdownOptions.fromDate || "",
                dropdownOptions.toDate || "",
                fmt,
                {
                    manager: dropdownOptions.manager?.value ?? dropdownOptions.manager ?? "",
                    supervisor: dropdownOptions.supervisor?.value ?? dropdownOptions.supervisor ?? "",
                    end_user: dropdownOptions.end_user?.value ?? dropdownOptions.end_user ?? "",
                    role: dropdownOptions.role?.value ?? dropdownOptions.role ?? "",
                    emplyoee_id: dropdownOptions.emplyoee_name?.value ?? dropdownOptions.emplyoee_name ?? "",
                    search,
                },
            );
            if (res?.data) {
                triggerBrowserDownload(
                    res,
                    `User_Item_Wise_Report.${fmt === "excel" ? "xlsx" : "pdf"}`,
                );
            } else {
                toast.error(res?.message || "Failed to generate Item-wise Report");
            }
        } finally {
            setBusyReport("");
        }
    };

    // User-wise Report = hierarchy (Manager → Supervisors → End Users) of the
    // most-specific selected user, one section each.
    const handleUserWiseReport = async (fmt) => {
        if (busyReport) return;
        const rootUserId =
            dropdownOptions.end_user ||
            dropdownOptions.supervisor ||
            dropdownOptions.manager ||
            "";
        if (!rootUserId) {
            toast.error("Please select a Manager, Supervisor or End User first.");
            return;
        }
        setBusyReport(`userwise-${fmt}`);
        try {
            const res = await downloadUserWiseReport(
                rootUserId,
                dropdownOptions.fromDate || "",
                dropdownOptions.toDate || "",
                fmt,
                {
                    manager: dropdownOptions.manager || "",
                    supervisor: dropdownOptions.supervisor || "",
                    end_user: dropdownOptions.end_user || "",
                    role: dropdownOptions.role || "",
                },
            );
            if (res?.data) {
                triggerBrowserDownload(
                    res,
                    `User_Wise_Report.${fmt === "excel" ? "xlsx" : "pdf"}`,
                );
            } else {
                toast.error(res?.message || "Failed to generate User-wise Report");
            }
        } finally {
            setBusyReport("");
        }
    };

    const handleUserAccountExport = (params) => {
        // Strip UI-only columns from the export payload:
        //   sr_no  — branded PDF generator auto-renders its own SR column, so
        //            sending sr_no produces a duplicate empty column.
        //   action — UI-only column (view buttons), has no data field.
        let exportColumns = params?.columns;
        try {
            const parsed = JSON.parse(params?.columns || "[]");
            if (Array.isArray(parsed)) {
                exportColumns = JSON.stringify(
                    parsed.filter((c) => c !== "sr_no" && c !== "action")
                );
            }
        } catch (_) {
            // leave columns as-is if it isn't valid JSON
        }

        return getAdminAllHREmployees({
            ...params,
            columns: exportColumns,
            search,
            forAccount: true,
            role:
                dropdownOptions.role?.value ?? dropdownOptions.role ?? "",
            emplyoee_id:
                dropdownOptions.emplyoee_name?.value ??
                dropdownOptions.emplyoee_name ??
                "",
            manager:
                dropdownOptions.manager?.value ?? dropdownOptions.manager ?? "",
            supervisor:
                dropdownOptions.supervisor?.value ??
                dropdownOptions.supervisor ??
                "",
            end_user:
                dropdownOptions.end_user?.value ?? dropdownOptions.end_user ?? "",
            from_date: dropdownOptions.fromDate || "",
            to_date: dropdownOptions.toDate || "",
        });
    };

    const handleFilterChange = async (key, value) => {
  let updated = { ...dropdownOptions };

  if (key === "emplyoee_name") {

  const val = value?.value ?? value ?? "";

  updated.emplyoee_name = val;

  setDropdownOptions(updated);

  await fetchTransferedFundData(updated);

  return;
}
  // 🔥 MANAGER
  if (key === "manager") {
    // updated.manager = value || "";
    const val = value?.value ?? value ?? "";
    updated.manager = val;
    updated.supervisor = "";
    updated.end_user = "";

    setDropdownOptions(updated);

    if (value) {
      // await fetchSupervisorsByManager(value);
      await fetchSupervisorsByManager(val)
    }

    await fetchTransferedFundData(updated);
    return;
  }
  // 🔥 SUPERVISOR
// 🔥 SUPERVISOR
if (key === "supervisor") {

  const val = value?.value ?? value ?? "";

  updated.supervisor = val;
  updated.end_user = "";

  setDropdownOptions(updated);

  if (val) {
    await fetchEndUsersBySupervisor(val);   // ⭐ API CALL
  } else {
    setEndUserData([]);
  }

  await fetchTransferedFundData(updated);

  return;
}
   updated[key] = value?.value ?? value ?? "";
  setDropdownOptions(updated);
  await fetchTransferedFundData(updated); 
};


    return (
        <>
         <DynamicFilter fields={fields} onChange={handleFilterChange} />
            <CustomTable
                id={"user_bank_accounts"}
                userPermission={checkPermission}
                isLoading={isLoading}
                rows={rows || []}
                columns={columns}
                pagination={{
                    pageNo,
                    pageSize,
                    totalData,
                }}
                customHeaderComponent={() => (
                    <div className="d-flex align-items-center gap-3">
                        <TableHeader
                            userPermission={checkPermission}
                            setSearchText={setSearch}
                            button={{ show: false }}
                        />
                        {/* Header download icons — each opens a Summary /
                            User-wise menu. Summary = filtered user list;
                            User-wise = selected user's hierarchy (manager →
                            supervisors → end users), one section each. */}
                        <Dropdown align="end">
                            <Dropdown.Toggle as={IconToggle} disabled={!!busyReport}>
                                {busyReport.endsWith("excel") ? (
                                    <Spinner animation="grow" size="sm" variant="success" />
                                ) : (
                                    <BsFileEarmarkExcelFill className="fs-4" color="#16a34a" title="Excel Report" />
                                )}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => handleSummaryReport("excel")}>
                                    {t("Summary Report")}
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => handleItemwiseReport("excel")}>
                                    {t("Item-wise Report")}
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => handleUserWiseReport("excel")}>
                                    {t("User-wise Report")}
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => handleComplaintWiseReport("excel")}>
                                    {t("Complaint Wise Report")}
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <Dropdown align="end">
                            <Dropdown.Toggle as={IconToggle} disabled={!!busyReport}>
                                {busyReport.endsWith("pdf") ? (
                                    <Spinner animation="grow" size="sm" variant="danger" />
                                ) : (
                                    <BsFileEarmarkPdfFill className="fs-4" color="#dc3545" title="PDF Report" />
                                )}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => handleSummaryReport("pdf")}>
                                    {t("Summary Report")}
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => handleItemwiseReport("pdf")}>
                                    {t("Item-wise Report")}
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => handleUserWiseReport("pdf")}>
                                    {t("User-wise Report")}
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => handleComplaintWiseReport("pdf")}>
                                    {t("Complaint Wise Report")}
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                )}
                tableTitleComponent={
                    <div>
                        <UserPlus /> <strong>User Bank Accounts</strong>
                    </div>
                }
            />
        </>
    );
};

export default UserBankAccounts;
